import BaseDiv from './Div';

// EXPORT
export const Div = BaseDiv;
export type { DivProps } from './Div.interface';
